export default function WaitingComponent() {
  return (
    <>
      <div className="waiting-icon">
        <img src="/locketgo-glyph-spin.gif" alt="" />
      </div>
    </>
  );
}
